import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ContainerDefault from '../../components/ContainerDefault';
import { ErrorMessage, Loading } from '../../components/UtilComponent';
import * as motoristaAction from '../../services/motorista/Action';
import * as Constants from '../../utils/constants';
import TablePessoa from '../pessoa/components/TablePessoa';
import Swal from 'sweetalert2';



class Index extends Component {

    constructor() {
        super()

        this.state = {
            checked: false
        };



    }

    componentDidMount() {
        this.props.action.getMotoristasAction(!this.state.checked);
    }
    handleClick = (event, id) => {
        console.log(id);
    };
    handleClickTodos = () => {
        this.setState({ checked: !this.state.checked });

        this.props.action.getMotoristasAction(this.state.checked);
    }

    handleClickDelete = (id, nome) => {
        Swal.fire({
            title: `${!this.state.checked ? 'Excluir': 'Ativar'} item?`,
            text: `Você realmente deseja ${!this.state.checked ? 'excluir': 'ativar'} a transportadora  ${nome} ? `,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            showLoaderOnConfirm: true,
            confirmButtonText: `Sim, ${!this.state.checked ? 'excluir': 'ativar'} essa transportadora!`,
            preConfirm: async (willDelete) => {
                try {
                    await this.props.action.desativarOrAtivarMotoristaByIdAction(id, this.state.checked);
                    await this.props.action.getMotoristasAction(!this.state.checked);
                    return 'ok'
                } catch (err) {
                    throw err;
                }
            },
            dangerMode: true,
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    text: `Operação realizada com sucesso!`,
                    icon: "success",
                });
            } else {
                Swal.fire({
                    text: "Operação cancelada!",
                    icon: "info",
                });
            }
        }).catch(err => {
            if (err) {
                Swal.fire({
                    text: `Operação cancelada! ${err['detail'] ? err['detail'] : ''}`,
                    icon: "error",
                });
            } else {
                Swal.stopLoading();
                Swal.close();
            }
        });
    }

    retornarDadosTela() {
        const { motoristaObject, messages, isLoading } = this.props;


        if (motoristaObject === null && isLoading) return (
            <Loading title={Constants.DESCRICAO_MOTORISTAS} />
        );

        return (<ContainerDefault
            title={Constants.DESCRICAO_MOTORISTAS}
            url={Constants.ROUTE_URL_TRANSPORTADORA}
            messages={messages}
            button={Constants.DESCRICAO_NOVO}
            container={<TablePessoa
                checked={this.state.checked}
                pessoaObject={motoristaObject === null ? [] : motoristaObject}
                edit_url={Constants.ROUTE_URL_TRANSPORTADORA}
                handleClickDelete={this.handleClickDelete}
                handleClickTodos={this.handleClickTodos}

            />}
        />);

    }
    render() {
        return this.retornarDadosTela();
    }
}

const mapStateToProps = state => ({
    motoristaObject: state.motoristaReducer.motoristaObject,
    messages: state.messageResponseReducer.messages,
    isLoading: state.apiReducer.isLoading

});

const mapDispatchToProps = dispatch => ({
    action: bindActionCreators(motoristaAction, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Index);
